module.exports = __webpack_public_path__ + "img/eoapp_AQUA_komplett.d116733c.png";